import { useContext, useState } from "react";
import "./login.scss";
import {
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import logo from "./final-logo-white.png";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";

// MFA enrollment modal removed

// MFA verification modal removed

// Email verification modal removed

const Login = () => {
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);

  // Email verification and MFA functions removed

  const handleLogin = (e) => {
    e.preventDefault();
    setError(false);
    
    // Authenticate the user with Firebase Auth - no verification or MFA check
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;

        // Now that user is authenticated, check permissions in Firestore
        const userQuery = query(
          collection(db, "users"),
          where("email", "==", email)
        );

        return getDocs(userQuery).then((querySnapshot) => {
          if (querySnapshot.empty) {
            throw new Error("User account not found. Please contact support.");
          }
          
          const userData = querySnapshot.docs[0].data();
          
          // Check if user has stationboard permission
          if (!userData.stationboard) {
            throw new Error("You do not have permission to access Stationboard");
          }
          
          return { userCredential, userData };
        });
      })
      .then((result) => {
        if (!result) return;

        // Everything checks out, log the user in
        dispatch({ type: "LOGIN", payload: result.userCredential.user });
        navigate("/");
      })
      .catch((error) => {
        // Sanitize error logging
        console.error("Login error:", error.code || "unknown error");

        if (
          error.code === "auth/wrong-password" ||
          error.code === "auth/user-not-found"
        ) {
          setError(new Error("Username or password is incorrect"));
        } else if (error.code === "auth/too-many-requests") {
          setError(
            new Error(
              "Too many failed login attempts. Please try again later or reset your password."
            )
          );
        } else {
          // Handle all other errors without MFA checking
          setError(error);
        }
      });
  };

  // MFA verification completion handler removed

  return (
    <div className="login-page">
      <div className="img-container">
        <div className="img-text"></div>
      </div>
      <div className="login-container">
        <img src={logo} alt="Logo" className="login-logo" />
        <form onSubmit={handleLogin} className="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
          />
          <div className="login-remember">
            <input type="checkbox" id="rememberMe" />
            <label htmlFor="rememberMe">Remember me</label>
          </div>
          <button type="submit" className="login-button">
            LOGIN
          </button>
          {error && (
            <span className="login-error">
              {error.message}
            </span>
          )}
        </form>
        <div className="warning">
          <span>* * * * * * * * W A R N I N G * * * * * * * *</span>
          <p>
            This system is the property of Ladder Suite LLC and is provided for
            official use by authorized government personnel and affiliated
            agencies only. Unauthorized access, use, or modification of this
            system is strictly prohibited and may result in disciplinary action,
            civil penalties, and/or criminal prosecution under applicable laws.
          </p>
          <p>
            All activity on this system is subject to monitoring, recording, and
            auditing. By proceeding, you expressly consent to such monitoring
            and acknowledge your obligation to comply with all applicable
            policies, including Ladder Suite’s Terms of Service and any
            governing agency regulations.
          </p>
          <p>
            If you are not an authorized user or do not agree to these
            conditions, <strong>log off immediately</strong>.
          </p>
          <br />
        </div>
      </div>
      {/* Verification and MFA modals removed */}
    </div>
  );
};

export default Login;
